import { render, staticRenderFns } from "./AutomationCompare.vue?vue&type=template&id=27642417"
import script from "./AutomationCompare.vue?vue&type=script&lang=js"
export * from "./AutomationCompare.vue?vue&type=script&lang=js"
import style0 from "./AutomationCompare.vue?vue&type=style&index=0&id=27642417&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports